import { useState } from "react";
import { useNavbarScroll } from "../../hooks/useNavbarScroll";
import { useActiveSection } from "../../hooks/useActiveSection";
import { NavbarLogo } from "./NavbarLogo";
import { NavbarLinks } from "./NavbarLinks";
import { NavbarCTA } from "./NavbarCTA";
import { NavbarHamburguer } from "./NavbarHamburguer";
import { NavbarMobile } from "./NavbarMobile";
import { NAVBAR_STYLES } from "./NavbarStyles";
import { NAV_LINKS, TIMING } from "./NavbarConfig";

export default function Navbar() {
  const [menuAberto, setMenuAberto] = useState<boolean>(false);
  const rolou = useNavbarScroll(TIMING.scrollThreshold);
  const activeSection = useActiveSection();

  const handleMenuToggle = () => setMenuAberto(!menuAberto);
  const handleMobileMenuClose = () => setMenuAberto(false);

  return (
    <>
      <style>{NAVBAR_STYLES}</style>

      <nav className={`nav ${rolou ? "nav--rolou" : ""}`}>
        <NavbarLogo />
        <NavbarLinks links={NAV_LINKS} activeSection={activeSection} />
        <NavbarCTA />
        <NavbarHamburguer isOpen={menuAberto} onClick={handleMenuToggle} />
      </nav>

      <NavbarMobile
        isOpen={menuAberto}
        links={NAV_LINKS}
        activeSection={activeSection}
        onLinkClick={handleMobileMenuClose}
      />
    </>
  );
}